import { render, staticRenderFns } from "./RemoveRules.vue?vue&type=template&id=34681504&scoped=true&"
import script from "./RemoveRules.vue?vue&type=script&lang=js&"
export * from "./RemoveRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34681504",
  null
  
)

export default component.exports